// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookCheckbox__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BookCheckbox/BookCheckbox.scss
 ** module id = 889
 ** module chunks = 1
 **/